<template>
    <div>
        <div v-if="errors" v-for="(key, error) in errors" v-text="errors[error][0]" class="alert alert-danger" role="alert">
        </div>
        <div class="set-price">
            <button type="button"
                class="btn btn-success btn-block"
                data-toggle="modal" data-target="#setPrices"> Set Prices
            </button>
        </div>

        <div v-if="!isLoading" class="modal fade" aria-hidden="true" id="setPrices" tabindex="-1" role="dialog" aria-labelledby="setPricesModalLabel">
            <div class="modal-dialog" role="document">

                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="set-price-header">
                            <h3>Set prices</h3>
                        </div>
                    </div>

                    <div class="container">
                        <div class="form-group ">
                            <label for="pixel-browser-traffic-price" class="col-sm-2 col-form-label">Pixel-browser traffic</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.browser_traffic_price" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="pixel-owned-websites-price" class="col-sm-2 col-form-label">Pixel-owned websites</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.owned_websites_price" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="traffic-code-redict-price" class="col-sm-2 col-form-label">Traffic-code redirect</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.traffic_code_redirect" />
                            </div>
                        </div>
                        <div class="form-group ">
                            <label for="traffic-code-static-price" class="col-sm-2 col-form-label">Traffic-code static</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.traffic_code_static" />
                            </div>
                        </div>
                        <div class="form-group ">
                            <label for="owned-website-iframes-price" class="col-sm-2 col-form-label">Owned Website Iframes</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.owned_website_iframes" />
                            </div>
                        </div>
                        <div class="form-group ">
                            <label for="iframe-traffic-code-static-price" class="col-sm-2 col-form-label">iframe-traffic code static</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.iframe_traffic_code_static" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="iframe-traffic-code-redirect-price" class="col-sm-2 col-form-label">iframe-traffic code redirect</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.iframe_traffic_code_redirect" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="server_to_server_logs" class="col-sm-2 col-form-label">server to server logs</label>
                            <div class="col-sm-10">
                                <input type="number" min="0" v-model="form.server_to_server_logs" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-5 text-center">
                                <button type="button" class="btn btn-primary" data-dismiss="modal" v-on:click="save()" aria-label="">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TrafficPrice",

        data: function () {
            return {
                form: {
                    browser_traffic_price: 0,
                    owned_websites_price: 0,
                    traffic_code_redirect: 0,
                    traffic_code_static: 0,
                    owned_website_iframes: 0,
                    iframe_traffic_code_static: 0,
                    iframe_traffic_code_redirect: 0,
                    server_to_server_logs: 0
                },
                isLoading: true,
                errors: {}
            }
        },
        mounted() {
            this.fetch();
        },
        methods: {
            fetch() {
                this.isLoading = true;
                axios.post('traffic-owner-report-requests/getPrices').then((response) => {
                    if (response.data) {
                        const trafficPrices = response.data;
                        this.form.browser_traffic_price = Number(trafficPrices.browser_traffic_price) || 0;
                        this.form.owned_websites_price = Number(trafficPrices.owned_websites_price) || 0;
                        this.form.traffic_code_redirect = Number(trafficPrices.traffic_code_redirect) || 0;
                        this.form.traffic_code_static = Number(trafficPrices.traffic_code_static) || 0;
                        this.form.owned_website_iframes = Number(trafficPrices.owned_website_iframes) || 0;
                        this.form.iframe_traffic_code_static = Number(trafficPrices.iframe_traffic_code_static) || 0;
                        this.form.iframe_traffic_code_redirect = Number(trafficPrices.iframe_traffic_code_redirect) || 0;
                        this.form.server_to_server_logs = Number(trafficPrices.server_to_server_logs) || 0;
                    }
                    this.isLoading = false;
                }).catch(({response, request}) => {
                    console.error(response);
                    this.isLoading = false;
                })
            },
            save() {
                this.isLoading = true;
                axios.post('traffic-owner-report-requests/storePrices', this.form).then((response) => {

                    this.isLoading = false;
                    this.errors = {},
                    this.$emit('reload');
                }).catch(({response, request}) => {
                    this.isLoading = false;
                    this.errors = response.data.errors;
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .set-price {
        width: 10em;
        margin-bottom: 1em;
    }
    .set-price-header {
        text-align: center;
        padding-top: 1em;
        padding-bottom: 1em;
    }
</style>



// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/traffic-log-owner-report/TrafficPrice.vue